<template>
<div style="padding: 20px;width: 100%">
  <el-row :gutter="20" class="balance-cards">
    <el-col :span="12" :sm="12" :md="8">
      <el-card shadow="hover" class="balance-card available">
        <div class="balance-title">
          <span>可提现金额</span>
          <el-tooltip content="可立即提现的金额" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <div class="balance-amount">¥ {{availableAmt}}</div>
        <el-button 
          type="primary" 
          size="small" 
          class="withdraw-btn"
          @click="visible=true"
        >立即提现</el-button>
      </el-card>
    </el-col>
    
    <el-col :span="12" :sm="12" :md="8">
      <el-card shadow="hover" class="balance-card frozen">
        <div class="balance-title">
          <span>冻结金额</span>
          <el-tooltip content="最近48小时内的收入将被冻结" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
        <div class="balance-amount">¥ {{freezing}}</div>
        <div class="frozen-tip">将于48小时后自动解冻</div>
      </el-card>
    </el-col>
  </el-row>

  <el-card shadow="hover">
    <el-form ref="queryFormRef" :model="queryParams" :inline="true">
      <el-form-item label="交易状态" prop="type">
        <el-select v-model="queryParams.type" placeholder="请选择">
          <el-option
              label="收入"
              value="1">
          </el-option>
          <el-option
              label="支出"
              value="-1">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发生时间" >
        <el-date-picker
            v-model="queryParams.params.createTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery">搜索</el-button>
        <el-button icon="Refresh" @click="resetQuery">重置</el-button>
        <el-button icon="Refresh" type="danger" @click="visible=true">提现</el-button>
      </el-form-item>
    </el-form>
  </el-card>
  <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @expand-change="expandChange"
      :lazy="true"
      :row-class-name="tableRowClassName">
    <el-table-column
        prop="amt"
        label="发生额"
    >
      <template #default="scope">
        <el-tag type="success"  effect="dark" v-if="scope.row.type==1">+{{scope.row.amt}}</el-tag>
        <el-tag type="info"  effect="dark" v-if="scope.row.type==-1">-{{scope.row.amt}}</el-tag>
      </template>
    </el-table-column>
    <el-table-column
        prop="balance"
        label="余额">
    </el-table-column>
    <el-table-column
        prop="category"
        label="分类">
      <template #default="scope">
        <el-tag type="success"  effect="dark" v-if="scope.row.category==0">收益</el-tag>
        <el-tag type="info"  effect="dark" v-if="scope.row.category==2">系统调整</el-tag>
        <el-tag type="danger"  effect="dark" v-if="scope.row.category==1">提现</el-tag>
        <el-tag type="danger"  effect="dark" v-if="scope.row.category==3">退款</el-tag>
      </template>
    </el-table-column>
    <el-table-column
        prop="createTime"
        label="发生时间">
    </el-table-column>
  </el-table>
  <el-pagination
      background
      layout="prev, pager, next,total"
      :page-size="12"
      :current-page="queryParams.pageNum"
      @current-change="currentChange"
      :total="total">
  </el-pagination>
  
  <el-dialog
    title="申请提现"
    :visible.sync="visible"
    width="400px"
    @open="open"
    center
    custom-class="withdrawal-dialog"
  >
    <!-- 余额信息 -->
    <div class="balance-info">
      <div class="balance-item">
        <span class="balance-label">可提现金额</span>
        <el-tag type="success" size="medium" effect="dark">¥ {{availableAmt}}</el-tag>
      </div>
      <div class="balance-item">
        <span class="balance-label">冻结金额</span>
        <el-tooltip content="48小时内收入将被冻结" placement="top">
          <el-tag type="info" size="medium">¥ {{freezing}}</el-tag>
        </el-tooltip>
      </div>
    </div>

    <!-- 提现表单 -->
    <el-form 
      ref="withdrawForm" 
      :model="form" 
      :rules="rules"
      label-position="top"
      class="withdraw-form"
    >
      <el-form-item label="真实姓名" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入真实姓名"
          prefix-icon="el-icon-user"
          clearable>
        </el-input>
      </el-form-item>

      <el-form-item label="支付宝账号" prop="zfb">
        <el-input
          v-model="form.zfb"
          placeholder="请输入支付宝账号"
          prefix-icon="el-icon-money"
          clearable>
        </el-input>
      </el-form-item>

      <el-form-item label="提现金额" prop="amt">
        <el-input
          v-model="form.amt"
          type="number"
          placeholder="请输入提现金额"
          prefix-icon="el-icon-wallet"
          clearable>
          <template #append>
            <el-button type="text" @click="setMaxAmount">全部提现</el-button>
          </template>
        </el-input>
      </el-form-item>
    </el-form>

    <!-- 操作按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submitWithdrawal" :loading="loading">
        确认提现
      </el-button>
    </div>
  </el-dialog>

  <el-card class="chart-card" shadow="hover" >
    <div class="chart-header">
      <h3 class="chart-title">收支统计</h3>
      <el-radio-group v-model="chartTimeRange" size="small" @change="updateChartData">
        <el-radio-button label="week">近7天</el-radio-button>
        <el-radio-button label="month">近30天</el-radio-button>
      </el-radio-group>
    </div>
    
    <div class="chart-container" ref="chartRef"></div>
    
    <!-- 数据概览 -->
    <div class="data-overview">
      <div class="overview-item">
        <span class="item-label">总收入</span>
        <span class="item-value income">¥ {{totalIncome}}</span>
      </div>
      <div class="overview-item">
        <span class="item-label">总支出</span>
        <span class="item-value expense">¥ {{totalExpense}}</span>
      </div>
      <div class="overview-item">
        <span class="item-label">净收入</span>
        <span class="item-value" :class="netIncome >= 0 ? 'income' : 'expense'">
          ¥ {{netIncome}}
        </span>
      </div>
    </div>
  </el-card>

</div>
</template>
<script>
import * as echarts from 'echarts'
import { getChartStatistics } from '../../api/knowledgeBase/statistics'

export default {
  methods: {
    open(){
      this.getAvailableAmt();
    },
    withdrawal(){
      if(this.form.amt>this.availableAmt){
        this.$message({
          message: '提现金额不能大于可提现金额',
          type: 'info'
        });
        this.loading=false;
        return
      }
      this.$http2({
        url: `/klgeek/balanceDetails/withdrawal`,
        method: 'post',
        data:this.form
      }).then((res) => {
        console.log(res)
        this.getlist();
      })
      this.visible=false;
    },
    getAvailableAmt(){
      this.$http2({
        url: `/klgeek/balanceDetails/availableAmt`,
        method: 'get',
      }).then((res) => {
        this.freezing=res.data.freezing;
        this.availableAmt=res.data.availableAmt;
      })
    },
    getlist(){
      if(this.queryParams.params.createTime[0]){
        this.queryParams.params.beginCreateTime=this.queryParams.params.createTime[0];
        this.queryParams.params.endCreateTime=this.queryParams.params.createTime[1];
      }
      this.$http2({
        url: `/klgeek/balanceDetails/mylist?pageNum=${this.queryParams.pageNum}&pageSize=${this.queryParams.pageSize}`,
        method: 'post',
        data:this.queryParams
      }).then((res) => {
        this.tableData=res.rows
        this.total=res.total
      })
    },
    handleQuery(){
      this.getlist();
    },
    currentChange(num){
      if(num){
        this.queryParams.pageNum=num
      }
      this.getlist();
    },
    resetQuery(){
      this.queryParams.params.createTime = [];
      this.queryParams.params.beginCreateTime = null;
      this.$refs.queryFormRef.resetFields();
      this.getlist();
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },
    loadUserInfo(userId,row) {
      this.$http({
        url: `/user/find/${userId}`,
        method: 'get'
      }).then((user) => {
        this.userInfo = user;
        row.user=user;
      })
    },
    async expandChange(row){
      if(row.user){
        return
      }
      this.loadUserInfo(row.createBy,row);
    },
    // 设置最大提现金额
    setMaxAmount() {
      this.form.amt = this.availableAmt;
    },
    
    // 提交提现
    submitWithdrawal() {
      this.$refs.withdrawForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.withdrawal()
          this.loading = false;
        }
      });
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef)
      this.updateChartData()
    },
    
    resizeChart() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    
    async updateChartData() {
      try {
        const res = await getChartStatistics(this.chartTimeRange)
        if(res.code === 200) {
          const data = res.data
          // 渲染图表
          this.renderChart({
            dates: data.dates,
            incomes: data.incomes,
            expenses: data.expenses
          })
          
          // 更新统计数据
          this.totalIncome = data.incomes.reduce((a, b) => a + Number(b), 0).toFixed(2)
          this.totalExpense = data.expenses.reduce((a, b) => a + Number(b), 0).toFixed(2)
          this.netIncome = (this.totalIncome - this.totalExpense).toFixed(2)
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
        this.$message.error('获取统计数据失败')
      }
    },
    
    renderChart(data) {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['收入', '支出'],
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.dates,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '金额 (元)'
        },
        series: [
          {
            name: '收入',
            type: 'line',
            smooth: true,
            data: data.incomes,
            itemStyle: {
              color: '#67C23A'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(103,194,58,0.3)' },
                { offset: 1, color: 'rgba(103,194,58,0.1)' }
              ])
            }
          },
          {
            name: '支出',
            type: 'line',
            smooth: true,
            data: data.expenses,
            itemStyle: {
              color: '#F56C6C'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(245,108,108,0.3)' },
                { offset: 1, color: 'rgba(245,108,108,0.1)' }
              ])
            }
          }
        ]
      }
      this.chart.setOption(option)
    },
    
    updateTotals(data) {
      this.totalIncome = data.incomes.reduce((a, b) => a + b, 0).toFixed(2)
      this.totalExpense = data.expenses.reduce((a, b) => a + b, 0).toFixed(2)
      this.netIncome = (this.totalIncome - this.totalExpense).toFixed(2)
    },
    // 生成模拟数据
    getMockData() {
      const days = this.chartTimeRange === 'week' ? 7 : 30
      const dates = []
      const incomes = []
      const expenses = []
      
      // 生成日期和数据
      for (let i = days - 1; i >= 0; i--) {
        const date = new Date()
        date.setDate(date.getDate() - i)
        dates.push(date.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' }))
        
        // 收入：500-2000的随机数，保留2位小数
        const income = +(Math.random() * 1500 + 500).toFixed(2)
        incomes.push(income)
        
        // 支出：200-800的随机数，保留2位小数
        const expense = +(Math.random() * 600 + 200).toFixed(2)
        expenses.push(expense)
      }
      
      // 添加一些趋势变化
      if (this.chartTimeRange === 'month') {
        // 月数据体现周期性
        for (let i = 0; i < 30; i++) {
          if (i % 7 === 0) { // 每周末收入高峰
            incomes[i] = +(Math.random() * 1000 + 1500).toFixed(2)
          }
          if (i % 15 === 0) { // 每半月支出高峰
            expenses[i] = +(Math.random() * 400 + 600).toFixed(2)
          }
        }
      } else {
        // 周数据体现递增
        for (let i = 0; i < 7; i++) {
          incomes[i] = +(incomes[i] * (1 + i * 0.1)).toFixed(2) // 收入缓慢增长
          if (i === 6) { // 周末收入翻倍
            incomes[i] *= 2
          }
        }
      }

      return {
        dates,
        incomes,
        expenses,
        // 添加一些统计数据
        totalIncome: incomes.reduce((a, b) => a + b, 0).toFixed(2),
        totalExpense: expenses.reduce((a, b) => a + b, 0).toFixed(2)
      }
    }
  },
  mounted(){
    this.getlist();
    this.getAvailableAmt();
    this.initChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) {
      this.chart.dispose()
    }
  },
  data() {
    // 金额验证规则
    const validateAmount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入提现金额'));
      } else if (value <= 0) {
        callback(new Error('提现金额必须大于0'));
      } else if (value > this.availableAmt) {
        callback(new Error('提现金额不能大于可提现金额'));
      } else {
        callback();
      }
    };
 // 支付宝账号验证规则（支持邮箱和手机号）
 const validateZfb = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入支付宝账号'));
      }
      // 邮箱正则
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // 手机号正则
      const phoneRegex = /^1[3-9]\d{9}$/;
      
      if (emailRegex.test(value) || phoneRegex.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的邮箱或手机号'));
      }
    };
    return {
      form:{
        amt:'',
        name:'',
        zfb:''
      },
      availableAmt:0,
      freezing:0,
      visible:false,
      showUser:false,
      pos: {
        x: '40%',
        y: '40%',
      },
      userInfo: '',
      total:0,
      way_code:[],
      state:[],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        params: {
          createTime: [],
          beginCreateTime:null,
          endCreateTime:''
        }
      },
      multipleSelection:[],
      tableData: [],
      loading: false,
      rules: {
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        zfb: [
          { required: true, message: '请输入支付宝账号', trigger: 'blur' }
        ],
        amt: [
          { required: true, message: '请输入提现金额', trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' }
        ]
      },
      chartTimeRange: 'week',
      chart: null,
      totalIncome: 0,
      totalExpense: 0,
      netIncome: 0
    }
  },
  watch: {
    chartTimeRange() {
      this.updateChartData()
    }
  }
}
</script>

<style scoped lang="scss">
.withdrawal-dialog {
  border-radius: 12px;
}

:deep(.el-dialog__header) {
  padding: 20px;
  border-bottom: 1px solid #EBEEF5;
}

:deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.balance-info {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
}

.balance-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.balance-label {
  font-size: 14px;
  color: #606266;
}

.withdraw-form {
  padding: 0 16px;
}

:deep(.el-form-item__label) {
  font-weight: 500;
  padding-bottom: 4px;
}

:deep(.el-input__inner) {
  height: 40px;
  line-height: 40px;
}

:deep(.el-input-group__append) {
  padding: 0 10px;
  color: #409EFF;
}

.dialog-footer {
  padding: 16px 20px;
  border-top: 1px solid #EBEEF5;
  text-align: right;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .withdrawal-dialog {
    width: 90% !important;
    margin: 0 auto;
  }
  
  .balance-info {
    flex-direction: column;
    gap: 12px;
  }
}

.chart-card {
  margin-top: 20px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.chart-container {
  height: 400px;
  margin-bottom: 20px;
}

.data-overview {
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.overview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.item-label {
  font-size: 14px;
  color: #909399;
}

.item-value {
  font-size: 20px;
  font-weight: 600;
}

.income {
  color: #67C23A;
}

.expense {
  color: #F56C6C;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .chart-container {
    height: 300px;
  }
  
  .data-overview {
    flex-direction: column;
    gap: 16px;
  }
  
  .overview-item {
    flex-direction: row;
    justify-content: space-between;
  }
}

/* 添加余额卡片样式 */
.balance-cards {
  margin-bottom: 20px;
}

.balance-card {
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  
  &.available {
    background: linear-gradient(135deg, #67C23A 0%, #85CE61 100%);
    color: white;
  }
  
  &.frozen {
    background: linear-gradient(135deg, #909399 0%, #A6A9AD 100%);
    color: white;
  }
  
  .balance-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    
    .el-icon-question {
      font-size: 14px;
      cursor: pointer;
      opacity: 0.8;
      
      &:hover {
        opacity: 1;
      }
    }
  }
  
  .balance-amount {
    font-size: 28px;
    font-weight: bold;
    margin: 12px 0;
  }
  
  .withdraw-btn {
    align-self: flex-start;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
  
  .frozen-tip {
    font-size: 14px;
    opacity: 0.8;
  }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .balance-cards {
    margin-bottom: 16px;
    
    .el-col {
      margin-bottom: 16px;
    }
  }
  
  .balance-card {
    height: 140px;
    padding: 16px;
    
    .balance-amount {
      font-size: 24px;
    }
  }
}
</style>